import { SchedulerGridHeader } from './header';
import { SchedulerGridWithoutTeam } from './withoutTeam';
import { SchedulerGridForemen } from './foremen';
import { getGridTemplateColumns } from './constants';
import { useSchedulerContext } from '@contexts/scheduler';
import { cn } from '@utils/cn';
import { useSchedulerResize } from '@hooks/scheduler/resize';
import { useDroppable } from '@dnd-kit/core';
import { useCallback, RefObject } from 'react';

export type SchedulerGridProps = {
  boundsRef?: RefObject<HTMLDivElement | null>;
};

export const SchedulerGrid = ({ boundsRef }: SchedulerGridProps) => {
  const { handlePointerUp, handlePointerMove, handlePointerLeave } = useSchedulerResize();

  const { setNodeRef } = useDroppable({ id: 'scheduler' });

  const {
    active: { cursor },
    hours,
    hoursCount,
  } = useSchedulerContext();

  const setRefs = useCallback(
    (node: HTMLDivElement | null) => {
      setNodeRef(node);
      if (boundsRef) boundsRef.current = node;
    },
    [setNodeRef, boundsRef],
  );

  return (
    <div
      id="scheduler-grid"
      ref={setRefs}
      className={cn(['relative grid', cursor])}
      onPointerUp={handlePointerUp}
      onPointerMove={handlePointerMove}
      onPointerLeave={handlePointerLeave}
      style={getGridTemplateColumns(hours.length || hoursCount)}>
      <SchedulerGridHeader />
      <SchedulerGridWithoutTeam />
      <SchedulerGridForemen />
    </div>
  );
};
